export default __webpack_public_path__ + "static/media/Pilgrim's Leggings of the Exalted Spirit.9d5b76dc.jpg";